import { Download, Visibility } from '@mui/icons-material';
import { Button } from '@mui/material';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { GetFileArchive } from 'Routes/Public/FileArchive/Adapters/GetFileArchive';

import React from 'react';

export default function CardDownloadButton({
  itemId,
  setIsDataLoading,
  isPreviewFile,
}) {
  const download_label = FindLangKey(
    'genral-public-btn-label-download-file'
  );
  const openFile_label = FindLangKey(
    'genral-public-btn-label-open-file'
  );

  return (
    <>
      <Button
        variant="contained"
        sx={{
          color: `${themeColors.ColorPrimary} !important`,
          maxHeight: '40px',
        }}
        fullWidth
        startIcon={
          isPreviewFile ? <Visibility /> : <Download />
        }
        onClick={() => {
          GetFileArchive(
            itemId,
            setIsDataLoading,
            isPreviewFile
          );
        }}
      >
        {isPreviewFile ? openFile_label : download_label}
      </Button>
    </>
  );
}
